import * as yup from "yup";
import moment from "moment";

export const funcionarioSchema = yup.object().shape({
  nome: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    )
    .required("Campo Obrigatório"),
  genero: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    )
    .required("Campo Obrigatório"),
  email: yup.string().email("Email Inválido"),
  contacto2: yup
    .string()
    .min(7, "Contacto tem que ter pelo menos 7 caracteres"),
  contacto: yup
    .string()
    .min(7, "Contacto tem que ter pelo menos 7 caracteres")
    .required("Campo Obrigatório"),
  endereco: yup.string(),
  cargo: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    ),
  nif: yup.number().typeError("Apenas Números").required("Campo Obrigatório"),
  // BI/CNI opcional: nem toda a gente o tem à mão no dia do cadastro, e
  // impedir o registo por causa disso trava a contratação.
  identificacao: yup.string(),
  nr_beneficiario: yup.string(),
  /* Unidade onde trabalha. Opcional e não obrigatória: o campo só aparece nas
     clínicas com mais de uma unidade, e exigi-lo bloqueava a submissão nas
     outras por causa de um campo que ninguém vê. */
  estabelecimento: yup.string(),
});

export const clienteSchema = yup.object().shape({
  genero: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    )
    .required("Campo Obrigatório"),
  email: yup.string().email("Email Inválido"),
  contacto2: yup
    .string()
    .min(7, "Contacto tem que ter pelo menos 7 caracteres"),
  contacto: yup
    .string()
    .min(7, "Contacto tem que ter pelo menos 7 caracteres")
    .required("Campo Obrigatório"),
  tel_trabalho: yup
    .string()
    .min(7, "Telefone tem que ter pelo menos 7 caracteres"),
  endereco: yup.string().required("Campo Obrigatório"),
  profissao: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    ),
  responsavel: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    ),
  data_nasc: yup
    .mixed()
    .required("Campo Obrigatório")
    .test("data-valida", "Data de nascimento inválida", (value) => {
      return value && moment.isMoment(value) && value.isValid();
    }),
  nif: yup.number().typeError("Apenas Números"),
  identificacao: yup.string(),
  nr_beneficiario: yup.string(),
  sms: yup.boolean().required("Campo Obrigatório"),
  com_email: yup.boolean().required("Campo Obrigatório"),
  com_whatsapp: yup.boolean().required("Campo Obrigatório"),
});

export const tratamentoSchema = yup.object().shape({
  codigo: yup.string(),
  designacao: yup.string().required("Campo Obrigatório"),
  precoParticular: yup.number().required("Campo Obrigatório"),
});

export const procedimentoSchema = yup.object().shape({
  codigo: yup.string().required("Campo Obrigatório"),
  nome: yup.string().required("Campo Obrigatório"),
  precoParticular: yup
    .number()
    .typeError("Apenas Números")
    .required("Campo Obrigatório"),
  precoBeneficiario: yup
    .number()
    .typeError("Apenas Números")
    .required("Campo Obrigatório"),
});

export const especialidadeSchema = yup.object().shape({
  nome: yup.string().required("Campo Obrigatório"),
});

export const consultaSchema = yup.object().shape({
  cliente: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    )
    .required("Campo Obrigatório"),
  data: yup.date("Data incorreta").required("Campo Obrigatório"),
  hora: yup.string("Hora incorreta").required("Campo Obrigatório"),
  observacao: yup.string(),
});

export const userSchema = yup.object().shape({
  nome: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    ),
  email: yup.string().email("Email Inválido"),
  contacto: yup.string().min(7, "Contacto tem que ter pelo menos 7 caracteres"),
  profissao: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    ),
  especiaidade: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    ),
  password: yup.string().min(7, "Passowrd com minimo 7 caracteres"),
});

export const edituserSchema = yup.object().shape({
  nome: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    )
    .required("Campo Obrigatório"),
  email: yup.string().email("Email Inválido"),
  contacto: yup
    .string()
    .min(7, "Contacto tem que ter pelo menos 7 caracteres")
    .required("Campo Obrigatório"),
});

export const clinicaSchema = yup.object().shape({
  nome: yup.string().required("Campo Obrigatório"),
  cidade: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    )
    .required("Campo Obrigatório"),
  endereco: yup.string(),
  ilha: yup
    .string()
    .matches(
      /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/,
      "Apenas letras são permitidas",
    )
    .required("Campo Obrigatório"),
  contacto: yup
    .string()
    .min(7, "Contacto tem que ter pelo menos 7 caracteres")
    .required("Campo Obrigatório"),
  email: yup.string().email("Email Inválido"),
  nif: yup.number().typeError("Apenas Números").required("Campo Obrigatório"),
  nrCertidao: yup.string().required("Campo Obrigatório"),
});
